export const BUYER_BOOKING_STATUS_DRAFT_OPTION = { text: 'Draft', value: 'draft', name: 'draft' };
export const BUYER_BOOKING_STATUS_NEW_OPTION = { text: 'Booking Linked', value: 'new', name: 'new' };
export const BUYER_BOOKING_STATUS_CHECK_LINKED_OPTION = { text: 'Credit Check Completed', value: 'check_linked', name: 'check_linked' };
export const BUYER_BOOKING_STATUS_LOAN_SUBMITTED_OPTION = { text: 'Lender Connected', value: 'loan_submitted', name: 'loan_submitted' };
export const BUYER_BOOKING_STATUS_SOLD_OPTION = { text: 'Sold', value: 'sold', name: 'sold' };
export const BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION = { text: 'Cancel Requested', value: 'cancel_requested', name: 'cancel_requested' };
export const BUYER_BOOKING_STATUS_CANCELLED_OPTION = { text: 'Cancelled', value: 'cancelled', name: 'cancelled' };
export const BUYER_BOOKING_STATUS_EXPIRED_OPTION = { text: 'Expired', value: 'expired', name: 'expired' };

const BUYER_BOOKING_STATUSES = [
  BUYER_BOOKING_STATUS_NEW_OPTION,
  BUYER_BOOKING_STATUS_CHECK_LINKED_OPTION,
  BUYER_BOOKING_STATUS_LOAN_SUBMITTED_OPTION,
  BUYER_BOOKING_STATUS_SOLD_OPTION,
  BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION,
  BUYER_BOOKING_STATUS_CANCELLED_OPTION,
  BUYER_BOOKING_STATUS_EXPIRED_OPTION,
];

export default BUYER_BOOKING_STATUSES;



// WEBPACK FOOTER //
// ./src/constants/buyerBookingStatuses.js